import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './styles';
import ElementsTab from './ElementsTab';
import SubElementsTab from './SubElementsTab';
import PF2MTabs from '~/components/PF2MTabs';
import LineupMask from '../LineupMask';

const Elements = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:Elements') },
    { key: 1, label: translate('common:SubElements') },
  ];

  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<LineupMask><ElementsTab /></LineupMask>) : null}
      {selectedTab === 1 ? (<LineupMask><SubElementsTab /></LineupMask>) : null}
    </>
  );
};

export default withStyles(styles)(Elements);
